import * as React from 'react';
import * as Classes from '../common/classes';
import { Icon } from '../icon/Icon';
import { mcSortAsc, mcSortDesc } from '@mc/react-ui-icons';
import { SortInfo } from './FinalTableProps';

export type ColumnSortProps = {
  sortInfo?: SortInfo;
  showDepth?: boolean;
};

export const ColumnSort = ({ sortInfo, showDepth }: ColumnSortProps) => {
  return (
    <div className={Classes.FINAL_TABLE_HEADER_SORT}>
      {sortInfo && <Icon icon={sortInfo.sort.asc ? mcSortAsc : mcSortDesc} />}
      {sortInfo && showDepth && (
        <div className={Classes.FINAL_TABLE_SORT_DEPTH}>
          {sortInfo.depth + 1}
        </div>
      )}
    </div>
  );
};
